import { IFirestoreAudioLinkRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreAudioLinkRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";
import { IAudioLink, IAudioLinkAsJson } from "../../../../dataObjects/models/digitalMedia/AudioLink";


export function saveAudioLink(audioLink: IAudioLink): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a AudioLink repository from the repository factory
      const firestoreAudioLinkRepository: IFirestoreAudioLinkRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.AudioLink) as
        IFirestoreBaseRepository<IAudioLink, IAudioLinkAsJson>;

      // determine if the audioLink already exists by calling the repository get() method to try and get the object
      const existingAudioLink: IAudioLink | undefined = await firestoreAudioLinkRepository.get(audioLink.id);

      // If the audioLink wasn't found, we will create a new instance. If it exists, we'll update the existing instance.
      if (existingAudioLink === undefined) {
        // call repository method to create the audioLink
        await firestoreAudioLinkRepository.create(audioLink);
      } else {
        // call repository method to update the audioLink
        await firestoreAudioLinkRepository.update(audioLink);
      }

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}